import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgLeaderboardDefaultAvatar = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsx("rect", {
    width: 39,
    height: 39,
    x: 0.5,
    y: 0.5,
    fill: "#F5F5F5",
    rx: 19.5
  }), /*#__PURE__*/_jsx("rect", {
    width: 39,
    height: 39,
    x: 0.5,
    y: 0.5,
    stroke: "#fff",
    rx: 19.5
  }), /*#__PURE__*/_jsx("path", {
    fill: "#333",
    d: "M22.79 20.429a.7.7 0 0 1 .41-.01c4.56 1.161 6.03 4.971 6.94 8.911a.75.75 0 0 1-.57.93h-.17a.76.76 0 0 1-.73-.58c-.91-3.97-2.15-6.68-5.41-7.68a4.5 4.5 0 0 1-6.52 0c-3.26 1-4.5 3.7-5.41 7.67a.762.762 0 0 1-1.17.441.75.75 0 0 1-.3-.78c.94-3.91 2.38-7.751 6.94-8.911a.72.72 0 0 1 .75.24 3.13 3.13 0 0 0 4.9 0 .7.7 0 0 1 .34-.231M20 9.25a5 5 0 0 1 4.81 5.18A5 5 0 0 1 20 19.6a5 5 0 0 1-4.81-5.17A5 5 0 0 1 20 9.25m0 1.5a3.52 3.52 0 0 0-3.31 3.68A3.51 3.51 0 0 0 20 18.1a3.51 3.51 0 0 0 3.31-3.67A3.52 3.52 0 0 0 20 10.75"
  })]
});
export default SvgLeaderboardDefaultAvatar;